module.exports = __webpack_public_path__ + "5de3e865c50a3a8c61384e53bcb34c77.gif";